// extracted by mini-css-extract-plugin
export var dropdownButton = "_4e-0";
export var fullWidthDropdownButton = "_4e-1";
export var icon = "_4e-3";
export var iconPlaceholder = "_4e-2";
export var menuItemRow = "_4e-9";
export var separator = "_4e-e";
export var shortcutContainer = "_4e-7";
export var shortcutContainerFilled = "_4e-8";
export var shortcutIconLg = "_4e-6";
export var shortcutIconMd = "_4e-5";
export var shortcutIconSm = "_4e-4";
export var submenuChevron = "_4e-d";
export var submenuDropdown = "_4e-a";
export var submenuTriggerRow = "_4e-b";
export var submenuTriggerRowOpen = "_4e-c";